var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isWorkflowShareable)?_c('AnemicButton',{staticClass:"share-button-container",attrs:{"tile":"","disabled":!_vm.canShare},on:{"click":function($event){$event.preventDefault();return _vm.openShareModuleDialog.apply(null, arguments)}}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }